import axios from 'axios';
import BaseApi from './base-api';
import numeral from 'numeral';

class DepositsApi extends BaseApi {
  getDeposits(page) {
    return axios
      .get(this.baseUrl + '/deposits?page=' + (page !== undefined ? page : 1))
      .then((response) => {
        return {
          ok: true,
          deposits: {
            content: response.data,
            total: numeral(response.headers['total']).value(),
            pageSize: numeral(response.headers['per-page']).value(),
          },
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  getDeposit(depositId) {
    return axios
      .get(`${this.baseUrl}/deposits/${depositId}`)
      .then((response) => {
        return {
          ok: true,
          deposit: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  markDepositAsPaid(depositId) {
    return axios
      .put(`${this.baseUrl}/deposits/${depositId}/paid`)
      .then((response) => {
        return {
          ok: true,
          deposit: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  getAsPdf(depositId) {
    return axios
      .get(`${this.baseUrl}/deposits/${depositId}/print`, {
        responseType: 'blob',
      })
      .then((response) => {
        return {
          ok: true,
          pdf: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  sendEmail(depositId, emails, subject, message) {
    const data = {
      deposit: {
        send_to: emails,
        subject: subject,
        message: message,
      },
    };
    return axios
      .put(`${this.baseUrl}/deposits/${depositId}/email`, data)
      .then((response) => {
        return {
          ok: true,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }
}

export let depositsApi = new DepositsApi();



// WEBPACK FOOTER //
// ./src/services/api/deposits-api.js